<template>
  <div>
    <GmapMap
      v-if="truckPath.length"
      ref="map"
      map-type-id="roadmap"
      :options="{ mapTypeControl: false }"
      :center="center"
      :zoom="zooom"
      style="height: 85vh; border: 4px solid blue"
    >
      <!-- Draw your trucking history here -->
      <GmapPolyline
        v-if="truckPath.length > 0"
        :path="formattedTruckPath"
        :options="{
          strokeColor: '#FF0000',
          strokeOpacity: 2.0,
          strokeWeight: 3,
        }"
      />
      <template v-for="(item, i) in tracking">
        <gmap-marker
          :key="i"
          :icon="getIcon(item.status, i)"
          @click="openWindow(item)"
          v-if="item.point"
          :position="{
            lat: item.point.coordinates[1],
            lng: item.point.coordinates[0],
          }"
        >
          <gmap-info-window
            v-if="active_id == item.id"
            @closeclick="window_open = false"
            :opened="window_open"
          >
            <div class="p-1 space-y-2" style="width: 250px">
              <p
                v-if="i == 0 || tracking.length - 1 == i"
                class="text-sm gap-4 flex items-center"
              >
                <span class="text-primary font-medium"> Status: </span>
                {{ i == 0 ? "Start" : "End" }}
              </p>
              <p class="text-sm gap-4 flex items-center w-full">
                <span class="text-primary font-medium"> Address: </span>
                -
              </p>
              <p class="text-sm gap-4 flex justify-between items-center w-full">
                <span class="text-primary font-medium"> Coordinates: </span>
                <span>
                  {{
                    item.point.coordinates[1] + ", " + item.point.coordinates[0]
                  }}
                </span>
              </p>
              <p class="text-sm gap-4 flex items-center">
                <span class="text-primary font-medium"> Odometer: </span>
                -
              </p>
              <p class="text-sm gap-4 flex items-center">
                <span class="text-primary font-medium"> Date: </span>
                {{ $dayjs(item.cr_time).format("dddd MMMM YYYY") }}
              </p>
              <a
                class="block font-medium text-xs"
                style="margin-top: 20px !important"
                :href="`https://www.google.com/maps?q=${item.point.coordinates[1]},${item.point.coordinates[0]}`"
                target="_blank"
                rel="noopener noreferrer"
              >
                View on google map
              </a>
            </div>
          </gmap-info-window>
        </gmap-marker>
      </template>
      <!-- <GmapMarker
        v-if="truckPath.length > 0"
        :position="formattedTruckPath[0]"
        :clickable="true"
      />
      <GmapMarker
        v-if="truckPath.length > 0"
        :position="formattedTruckPath[formattedTruckPath.length - 1]"
        :clickable="true"
      /> -->
    </GmapMap>
    <div v-else class="mt-20 flex items-center justify-center">
      <h1 class="text-6xl">No trackings</h1>
    </div>
  </div>
</template>
<script>
import { gmapApi } from "vue2-google-maps";
import marker from "../../../assets/images/map-icons/marker.png";
import rectangle_icon from "../../../assets/images/map-icons/rectangle_icon.svg";
import circle_icon from "@/assets/images/map-icons/circle_icon.svg";
import arrow_icon from "@/assets/images/map-icons/arrow_icon.svg";
export default {
  data() {
    return {
      center: { lat: 0, lng: 0 }, // Initial center of the map
      zoom: 10,
      zooom: 3,
      active_id: null,
      // Initial zoom level
      truckPath: [], // Array to store trucking history path,
      window_open: false,
    };
  },
  computed: {
    tracking() {
      return this.$store.state.log.tracking;
    },
    formattedTruckPath() {
      // Convert each entry in truckPath to objects with lat and lng keys
      return this.truckPath.map(([lng, lat]) => ({ lat, lng }));
    },
  },
  mounted() {
    this.loadTruckingHistory();
    // Call a method to load trucking history data and update truckPath
  },
  methods: {
    async loadTruckingHistory() {
      await this.$store.dispatch("log/fetchTracking", {
        driver_id: this.$route.params.id,
        day: this.$route.query.date,
      });
      this.truckPath = this.tracking
        .filter((x) => x.point)
        .map((x) => x.point.coordinates);
      setTimeout(() => {
        const bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < this.truckPath.length; i++) {
          bounds.extend({
            lat: this.truckPath[i][1],
            lng: this.truckPath[i][0],
          });
        }
        this.$refs.map.fitBounds(bounds);
      }, 1000);
    },
    openWindow(item) {
      this.active_id = item.id;
      this.window_open = true;
    },
    getIcon(status, index) {
      if (index == 0) {
        return "https://maps.google.com/mapfiles/kml/paddle/blu-blank.png";
      } else if (
        status == "DRIVING" ||
        (status == "D" && this.tracking.length - 1 == index)
      ) {
        return arrow_icon;
      } else if (this.tracking.length - 1 == index) {
        return "https://maps.google.com/mapfiles/kml/paddle/blu-blank.png";
      } else {
        return circle_icon;
      }
    },
  },
};
</script>